export default defineNuxtPlugin(() => {
   usePiniaPersist();
});
